import { Edit, SaveButton, Toolbar, DeleteButton } from 'react-admin';

import AgencyFields from './Fields';
import { AgencyTitle } from '.';
import { useAuth } from '../../../hooks/useAuth';

// Delete stays full-admin only; Lite Admins (#73) and principals edit PURL agency
// info but never see a delete control.
const AgencyEditToolbar = ({ showDelete }) => (
    <Toolbar>
        <SaveButton />
        {showDelete && <DeleteButton />}
    </Toolbar>
);

export const AgencyEdit = (props) => {
    const { user, canDelete } = useAuth();
    return (
        <Edit title={<AgencyTitle />} redirect="list" {...props}>
            <AgencyFields toolbar={<AgencyEditToolbar showDelete={canDelete(user)} />} />
        </Edit>
    );
};

export default AgencyEdit;
